import main from "../assets/images/main.svg";
import Wrapper from "../assets/wrappers/LandingPage";
import { Link } from "react-router-dom";
import { Logo } from "../components";
import Carousel from "react-gallery-carousel";
import buildingTemplates from "../utils/buildingTemplates";
import { IoQrCodeOutline } from "react-icons/io5";
import styled from "styled-components";

const FooterWrapper = styled.footer`
  background: #f9f9f9;
  margin-top: 2rem;
  margin-bottom: 2rem;
  padding: 3rem 1rem;
`;

const FooterContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;

  /* ברוחב עד 768px – פריסה לאורך */
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    text-align: center;      /* ממרכזים את הטקסט בעמודה */
    gap: 1.5rem;             /* קצת פחות ריווח למובייל */
    padding: 0 1rem;         /* שוליים פנימיים בהתאמה */
  }
`;

const FooterCol = styled.div`
  h4 {
    font-size: 1.1rem;
    margin-bottom: 0.5rem;
    color: #0a2540;
  }
  ul {
    list-style: none;
    padding: 0;
    li {
      margin: 0.4rem 0;
      a {
        color: #327d9c;
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
      }
      &:not(:has(a)) {
        color: #0a2540;
      }
    }
  }
`;

const ContactSection = styled.section`
  background: #fff;
  padding: 3rem 2rem;
  text-align: center;

  h2 {
    font-size: 1.8rem;
    margin-bottom: 1.5rem;
    color: #0a2540;
  }

  form {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    @media (max-width: 600px) {
      grid-template-columns: 1fr;
    }

    input,
    textarea {
      padding: 0.8rem;
      border: 1px solid #ddd;
      border-radius: 6px;
      font-size: 1rem;
      width: 100%;
    }

    textarea {
      grid-column: span 2;
      @media (max-width: 600px) {
        grid-column: span 1;
      }
    }

    button {
      grid-column: span 2;
      justify-self: start;
      background: #327d9c;
      color: #fff;
      padding: 0.8rem 1.5rem;
      border: none;
      border-radius: 6px;
      font-size: 1rem;
      cursor: pointer;
      &:hover {
        opacity: 0.9;
      }
      @media (max-width: 600px) {
        grid-column: span 1;
      }
    }
  }
`;

const Landing = () => {
  const images = buildingTemplates.map((template) => ({
    src: template.image,
  }));

  return (
    <Wrapper>
      <nav>
        <Logo />
      </nav>
      <div className="container page">
        <div className="info">
          <h1 style={{ marginTop: "20px" }}>
            מסכים <span>דיגיטלים</span> חכמים
          </h1>
          <p>
            הדרך הטובה ביותר לשתף מידע עם הדיירים שלך Fuzz TV היא חברה המציעה
            שירותי מסכים דיגיטליים לבניינים. השירות שלנו מאפשר לך לשתף מידע עם
            הדיירים שלך בצורה יעילה וברורה. עם Fuzz TV, אתה יכול: להציג הודעות
            דיירים לשתף חדשות מתפרצות להציג מזג אוויר לשתף תמונות Fuzz TV היא
            הפתרון המושלם לשיפור התקשורת עם הדיירים שלך.
          </p>
          <Link to="/register" className="btn register-link">
            רישום
          </Link>
          <Link to="/login" className="btn">
            כניסה
          </Link>
          <Link
            to="/connect"
            className="connect-btn-container"
          >
            <IoQrCodeOutline />
            הצג מסך
          </Link>
        </div>
        
      </div>
    </Wrapper>
  );
};

export default Landing;
